import { Loader2 } from "lucide-react";

/** Compact inline spinner — use inside buttons or next to text */
export function Spinner({ size = 16, className = "" }) {
  return <Loader2 size={size} className={`animate-spin ${className}`} />;
}

/** Centered full-section spinner — use as a page/section loading state */
export function PageLoader({ label = "Loading…" }) {
  return (
    <div data-testid="page-loader" className="flex flex-col items-center justify-center py-24 gap-4">
      <Loader2 size={40} className="animate-spin text-[#002FA7]" />
      <div className="font-mono-accent text-xs text-[#525252]">{label}</div>
    </div>
  );
}
